import GroupedDevicesTable from "./GroupedDevicesTable";

/**
 * DevicesTable - displays devices grouped by SKU Serial Number.
 *
 * This component uses the master-detail pattern to show:
 * - Master row: SKU summary (SKU, SKU SN, Configuration, aggregate Status)
 * - Detail row: Individual device components with their details
 * @return {JSX.Element} The devices table
 */
const DevicesTable = (): JSX.Element => {
  return <GroupedDevicesTable />;
};

export default DevicesTable;
